/**
 * The tokens DeWiCats auctions were settled in, plus the ones holdings pay out.
 *
 * These are fixed on chain, so there is no reason to look them up at runtime.
 * `logo` points at a local asset when we have one; components must treat a
 * missing logo as "render no icon" rather than assuming an image exists.
 */
export type TokenInfo = {
  mint: string
  symbol: string
  decimals: number
  /** Path under /public, or null when we do not ship a logo for this token. */
  logo: string | null
}

export const TOKENS: TokenInfo[] = [
  {
    mint: 'So11111111111111111111111111111111111111112',
    symbol: 'SOL',
    decimals: 9,
    logo: '/assets/solSymbol.svg',
  },
  {
    mint: 'hntyVP6YFm1Hg25TN9WGLqM12b8TQmcknKrdu1oxWux',
    symbol: 'HNT',
    decimals: 8,
    logo: '/assets/hntSymbol.svg',
  },
  {
    mint: 'mb1eu7TzEc71KxDpsmsKoucSSuuoGLv1drys1oP2jh6',
    symbol: 'MOBILE',
    decimals: 6,
    logo: '/assets/mobileSymbol.svg',
  },
  {
    mint: 'iotEVVZLEywoTn1QdwNPddxPWszn3zFhEot3MfL9fns',
    symbol: 'IOT',
    decimals: 6,
    logo: '/assets/iotSymbol.svg',
  },
  {
    mint: 'he1iusmfkpAdwvxLNGV8Y1iSbj4rUy6yMhEA3fotn9A',
    symbol: 'HELIUS',
    decimals: 9,
    logo: '/assets/helius_logo.png',
  },
  {
    mint: 'WAYRUy2VkqUCBg49sUSmJ2wYHzWpVjokZfQiGzdrAV3',
    symbol: 'WAYRU',
    decimals: 6,
    logo: '/assets/wayru.png',
  },
  {
    mint: 'EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v',
    symbol: 'USDC',
    decimals: 6,
    logo: null,
  },
  {
    mint: '4vMsoUT2BWatFweudnQM1xedRLfJgJ7hswhcpz4xgBTy',
    symbol: 'HONEY',
    decimals: 9,
    logo: null,
  },
  {
    mint: 'AmgUMQeqW8H74trc8UkKjzZWtxBdpS496wh4GLy2mCpo',
    symbol: 'TOKE',
    decimals: 3,
    logo: null,
  },
  {
    mint: 'rndrizKT3MK1iimdxRdWabcF7Zg7AR5T4nud4EkHBof',
    symbol: 'RENDER',
    decimals: 8,
    logo: null,
  },
  {
    mint: 'JUPyiwrYJFskUPiHa7hkeR8VUtAeFoSYbKedZNsDvCN',
    symbol: 'JUP',
    decimals: 6,
    logo: null,
  },
  {
    mint: 'HJ39rRZ6ys22KdB3USxDgNsL7RKiQmsC3yL8AS3Suuku',
    symbol: 'UPDOG',
    decimals: 9,
    logo: null,
  },
  {
    mint: 'METAewgxyPbgwsseH8T16a39CQ5VyVxZi9zXiDPY18m',
    symbol: 'META',
    decimals: 6,
    logo: null,
  },
  {
    mint: 'xNETbUB7cRb3AAu2pNG2pUwQcJ2BHcktfvSB8x1Pq6L',
    symbol: 'XNET',
    decimals: 8,
    logo: null,
  },
  {
    mint: 'ENTxR2RP8NtvhXzMNFCxE1HazzdV9x7SuZqGyAb4jdED',
    symbol: 'ENTROPY',
    decimals: 6,
    logo: null,
  },
  {
    mint: 'METADDFL6wWMWEoKTFJwcThTbUmtarRJZjRpzUvkxhr',
    symbol: 'METADAO',
    decimals: 6,
    logo: null,
  },
  {
    mint: '6p6xgHyF7AeE6TZkSmFsko444wqoP15icUSqi2jfGiPN',
    symbol: 'TRUMP',
    decimals: 6,
    logo: null,
  },
  {
    mint: 'fndrGakKBX8qzkfzRn6ktbktNtxV23vK7EtMCWnSsZw',
    symbol: 'FNDRS',
    decimals: 6,
    logo: null,
  },
]

const byMint = new Map(TOKENS.map((token) => [token.mint, token]))

export function tokenByMint(
  mint: string | { toBase58: () => string } | null | undefined,
): TokenInfo | undefined {
  if (!mint) return undefined
  const address = typeof mint === 'string' ? mint : mint.toBase58()
  return byMint.get(address)
}
